import { Button, Modal, InputNumber, Input, Row, Col, Typography } from 'antd';
import { PercentageOutlined, OrderedListOutlined, FileTextOutlined } from '@ant-design/icons';
import PropTypes from "prop-types";
import { useEffect, useState } from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';
import { COLORS } from '../../../components/ui/colors';

const { Title, Text } = Typography;
const { TextArea } = Input;

const TauxFractionnement = (props) => {
    const [rang, setRang] = useState(0);
    const [taux, setTaux] = useState(0);
    const [libelle, setLibelle] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleAdd = () => {
        setLoading(true);
        const tf = {
            ...props.tauxFractionnement,
            rang: parseInt(rang),
            taux: parseFloat(taux),
            libelleTauxFractionnement: libelle,
            fractionnement: props?.fractionnement
        }
        if (editMode) {
            axiosInstance.put("/api/taux-fractionnement", tf)
                .then((res) => {
                    setIsModalOpen(false);
                    toast.success("Taux de fractionnement ajouté avec succès");
                    setLoading(false);
                })
                .catch((err) => {
                    console.error("Error adding taux fractionnement:", err);
                    toast.error("Erreur lors de l'ajout");
                    setLoading(false);
                });
        } else {
            axiosInstance.post("/api/taux-fractionnement", tf)
                .then((res) => {
                    setIsModalOpen(false);
                    toast.success("Taux de fractionnement ajouté avec succès");
                    setLoading(false);
                })
                .catch((err) => {
                    console.error("Error adding taux fractionnement:", err);
                    toast.error("Erreur lors de l'ajout");
                    setLoading(false);
                });
        }

    };

    const handleCancel = () => {
        setRang(0);
        setTaux(0);
        setLibelle("");
        setIsModalOpen(false);
    }

    useEffect(() => {
        if (props.edit) {
            setRang(props.tauxFractionnement.rang);
            setTaux(props.tauxFractionnement.taux);
            setLibelle(props.tauxFractionnement.libelleTauxFractionnement);
            setEditMode(true);
        }
    }, [props.edit]);

    useEffect(() => {
        setIsModalOpen(props.open);
    }, [props.open]);


    useEffect(() => {
        if (!isModalOpen) {
            props.setOpen(false);
        }
    }, [isModalOpen]);

    const labelStyle = { display: "block", marginBottom: 6, fontWeight: 600, color: COLORS.secondary };

    return (
        <Modal
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
            centered
            width={560}
            bodyStyle={{ padding: 0, borderRadius: 16, overflow: "hidden" }}
            style={{ borderRadius: 16, overflow: "hidden" }}
        >
            {/* En-tête dégradé */}
            <div style={{
                background: COLORS.gradient, padding: "22px 28px", color: "#fff",
                display: "flex", alignItems: "center", gap: 14,
            }}>
                <div style={{
                    width: 46, height: 46, borderRadius: 12, background: "rgba(255,255,255,0.18)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                    <PercentageOutlined style={{ fontSize: 22, color: "#fff" }} />
                </div>
                <div>
                    <Title level={4} style={{ color: "#fff", margin: 0 }}>
                        {editMode ? "Modifier le taux" : "Nouveau taux de fractionnement"}
                    </Title>
                    {props?.fractionnement?.libelleFractionnement && (
                        <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 13 }}>
                            {props.fractionnement.libelleFractionnement}
                        </Text>
                    )}
                </div>
            </div>

            <div style={{ padding: "24px 28px" }}>
                <Row gutter={16}>
                    <Col xs={12}>
                        <label style={labelStyle}>Rang</label>
                        <InputNumber
                            size="large" style={{ width: "100%" }} min={1}
                            prefix={<OrderedListOutlined style={{ color: "#bbb" }} />}
                            placeholder="Ex : 1, 2…"
                            value={rang === 0 || rang === '' ? null : Number(rang)}
                            onChange={(v) => setRang(v ?? 0)}
                        />
                    </Col>
                    <Col xs={12}>
                        <label style={labelStyle}>Taux</label>
                        <InputNumber
                            size="large" style={{ width: "100%" }} min={0} max={100} step={0.01}
                            addonAfter="%"
                            placeholder="Ex : 5"
                            value={taux === 0 || taux === '' ? null : Number(taux)}
                            onChange={(v) => setTaux(v ?? 0)}
                        />
                    </Col>
                </Row>

                <div style={{ marginTop: 18 }}>
                    <label style={labelStyle}><FileTextOutlined style={{ marginRight: 6 }} />Libellé</label>
                    <TextArea
                        rows={3}
                        placeholder="Libellé du taux (ex : 1er versement, 2e versement…)"
                        value={libelle}
                        onChange={(e) => setLibelle(e.target.value)}
                    />
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 24 }}>
                    <Button size="large" onClick={handleCancel} style={{ borderRadius: 8 }}>
                        Annuler
                    </Button>
                    <Button
                        size="large" type="primary" loading={loading} onClick={handleAdd}
                        style={{ borderRadius: 8, background: COLORS.gradient, border: "none", fontWeight: 600, minWidth: 130 }}
                    >
                        {editMode ? "Modifier" : "Enregistrer"}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

TauxFractionnement.propTypes = {
    open: PropTypes.bool,
    tauxFractionnement: PropTypes.object,
    fractionnement: PropTypes.object,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
};

export default TauxFractionnement